module.exports = __webpack_public_path__ + "static/media/welcome.fd16528f.png";